import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, CabinEventClient, CabinEventReport, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useGetCabinEventReport(id: number, role: AuthorizationRequestType) {
  return useQuery<CabinEventReport, ProblemDetails>({
    queryKey: [queryKeys.CabinEvent.Get, { id }],
    queryFn: () => cabinEventClient.get(id, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetCabinEventReport;
